import { useCover } from '../lib/cover';

/**
 * 封面图，显示前按 App 的规则处理：白线稿染成主题棕，彩色插画原样。
 * 单独抽成组件是因为它要调 hook，没法在 albums.map 里直接写。
 */
export function CoverArt({ src, className, alt = '' }: {
  src: string | null | undefined;
  className?: string;
  alt?: string;
}) {
  const resolved = useCover(src);
  if (!resolved) return null;
  return <img className={className} src={resolved} alt={alt} />;
}
